/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  GetEffectiveNotificationPreferencesByKindQueryResponse,
  GetEffectiveNotificationPreferencesByKindPathParams,
} from '../../types/GetEffectiveNotificationPreferencesByKind'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getEffectiveNotificationPreferencesByKind } from '../../clients/getEffectiveNotificationPreferencesByKind'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getEffectiveNotificationPreferencesByKindQueryKey = ({
  kind_slug,
}: {
  kind_slug: GetEffectiveNotificationPreferencesByKindPathParams['kind_slug']
}) =>
  [
    {
      url: '/api/v1/notifications/preferences/kind/:kind_slug/',
      params: { kind_slug: kind_slug },
    },
  ] as const

export type GetEffectiveNotificationPreferencesByKindQueryKey = ReturnType<
  typeof getEffectiveNotificationPreferencesByKindQueryKey
>

export function getEffectiveNotificationPreferencesByKindQueryOptions(
  {
    kind_slug,
  }: {
    kind_slug: GetEffectiveNotificationPreferencesByKindPathParams['kind_slug']
  },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getEffectiveNotificationPreferencesByKindQueryKey({
    kind_slug,
  })
  return queryOptions<
    GetEffectiveNotificationPreferencesByKindQueryResponse,
    ResponseErrorConfig<Error>,
    GetEffectiveNotificationPreferencesByKindQueryResponse,
    typeof queryKey
  >({
    enabled: !!kind_slug,
    queryKey,
    queryFn: async ({ signal }) => {
      return getEffectiveNotificationPreferencesByKind(
        { kind_slug: kind_slug },
        { ...config, signal: config.signal ?? signal }
      )
    },
  })
}

/**
 * @summary Get the effective per-preference settings for a kind
 * {@link /api/v1/notifications/preferences/kind/:kind_slug/}
 */
export function useGetEffectiveNotificationPreferencesByKind<
  TData = GetEffectiveNotificationPreferencesByKindQueryResponse,
  TQueryData = GetEffectiveNotificationPreferencesByKindQueryResponse,
  TQueryKey extends QueryKey =
    GetEffectiveNotificationPreferencesByKindQueryKey,
>(
  {
    kind_slug,
  }: {
    kind_slug: GetEffectiveNotificationPreferencesByKindPathParams['kind_slug']
  },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetEffectiveNotificationPreferencesByKindQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ??
    getEffectiveNotificationPreferencesByKindQueryKey({ kind_slug })

  const query = useQuery(
    {
      ...getEffectiveNotificationPreferencesByKindQueryOptions(
        { kind_slug },
        config
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
